export function isValidGatewayPort(value: string): boolean {
  const trimmed = value.trim()
  if (!/^\d+$/.test(trimmed)) {
    return false
  }

  const port = Number.parseInt(trimmed, 10)
  return port >= 1 && port <= 65535
}
